import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IonicModule } from '@ionic/angular';

import { ModalAssetDownloadComponent } from './modal-asset-download.component';

@NgModule({
  imports: [CommonModule, IonicModule],
  declarations: [ModalAssetDownloadComponent],
  providers: [],
})
export class ModalAssetDownloadModule {}
